export default String.raw`
{% assign name = include -%}
{% assign productsObject = [name] -%}
{% assign bannerTitle = settings[bannerName] -%}

{% if config.Banners[bannerTitle] -%} 
    {% assign banner = config.Banners[bannerTitle] -%} 
    <div class="bannerPromo">
        {% if banner.Images[0] != null -%}
            {% assign bannerImage = banner.Images[0] -%}
            {% assign bannerHasHeading = false -%}
            {% if bannerImage.Heading != '' and bannerImage.Heading != ' ' -%}
                {% assign bannerHasHeading = true -%}
            {% endif -%}

            {% assign bannerLink = '' -%}
            {% if bannerImage.Link != '' -%}
                {% capture bannerLink -%}{% include 'partials/common/user-link.html', userLink: bannerImage.Link -%}{% endcapture -%}
            {% endif -%}

            {% assign bannerImageClickable = false -%}
            {% if bannerLink != '' and bannerHasHeading == false -%}
                {% assign bannerImageClickable = true -%}
            {% endif -%}

            {% capture bannerContent -%}
                <picture class="bannerPromo__image lazy" title="{{ bannerImage.Title }}">
                    <source media="(max-width: 767px)" srcset="{{ bannerImage.UrlSmall }}" type="image/webp">
                    <source media="(max-width: 767px)" srcset="{{ bannerImage.UrlSmall }}">
                    <source media="(max-width: 1439px)" srcset="{{ bannerImage.UrlMedium }}" type="image/webp">
                    <source media="(max-width: 1439px)" srcset="{{ bannerImage.UrlMedium }}">
                    <source srcset="{{ bannerImage.Url }}" type="image/webp">

                    <img src="{{ bannerImage.Url }}" 
                        alt="{{ bannerImage.Alt }}"
                        width="720" 
                        height="860"
                        decoding="{% if forloop.index0 == 0 -%}sync{% else -%}async{% endif -%}"
                        {% unless settings.bodyMainBannerNo_1 == 1 -%}loading="{% if forloop.index0 == 0 -%}eager{% else -%}lazy{% endif -%}"{% else -%}fetchpriority="high"{% endunless -%}
                        >
                </picture>

                <div class="bannerPromo__texts">
                    <div class="bannerPromo__info">
                    
                        {% if bannerHasHeading -%}
                            <p class="bannerPromo__title">{{bannerImage.Heading | Truncate: 50, "…"}}</p>
                        {% endif -%}
    
                        {% if bannerImage.Text != '' -%}
                            <p class="bannerPromo__title bannerPromo__title__small">{{bannerImage.Text | Truncate: 200, "…"}}</p>
                        {% endif -%} 
                    </div>
                    {% if bannerLink != '' and bannerHasHeading -%}
                        <a href="{{bannerLink}}" class="primary-action-button" {% if bannerImage.TargetBlank == true -%} target="_blank" rel="noopener noreferrer" {% endif -%}>
                            {{translations.Check}}
                        </a>
                    {% endif -%} 
                </div>
            {% endcapture -%}

            {% if bannerImageClickable -%}
                <a class="bannerPromo__wrapper" href="{{bannerLink}}" target="{% if bannerImage.TargetBlank == true -%}_blank{% else -%}_self{% endif -%}" {% if bannerImage.TargetBlank == true -%} rel="noopener noreferrer" {% endif -%}>
                    {{ bannerContent }}
                </a>
            {% else -%}
                <div class="bannerPromo__wrapper">
                    {{ bannerContent }}
                </div>
            {% endif -%}
        {% else -%}
            <div class="bannerPromo__wrapper">
                <figure class="bannerPromo__image bannerPromo__image-placeholder">
                    <img data-lazy="css/img/img-placeholder.jpg" src="css/img/alo.gif" alt="{{translations.DefaultImage}}" width="720" height="860">
                </figure>
                <h1 class="bannerPromo__placeholder">{{bannerTitle}}<br>720x860<br></h1>
            </div>
        {% endif -%}

        <div class="bannerPromo__swiper">
            {% assign productsList = productsObject.Products | Randomize | Take: 4 -%}
            <div class="swiper-wrapper bannerPromo__products">
                {% for product in productsList -%}
                    <div class="swiper-slide bannerPromo__slide">
                        {% include 'partials/common/card-product.html' with product -%}
                    </div>
                {% endfor -%}
            </div>
        </div>

        <div class="wishListInfoPopup" style="display: none">
			{{translations.PrList_LogInToWishList}}
		</div>
    </div>
{% endif -%}
`